import React from 'react'
import { Link } from 'react-router-dom'

export default function ImgContent({ params }) {
    return (

        <section id={params.id} className="why-us section-bg">
            <div className="container-fluid" data-aos="fade-up">

                <div className="row">
                    <div className="col-lg-7 d-flex flex-column justify-content-center align-items-stretch  order-1 order-lg-2">

                        <div className="content">
                            <h2>{params.heading}</h2>
                            <p>
                                {params.content}
                            </p>
                            <button type="button" className="btn btn-outline-primary rounded-pill btn-lg px-5 py-2"><Link to="/learnmore">Learn More</Link></button>
                        </div>
                    </div>

                    <div className="col-lg-5 align-items-stretch order-2 order-lg-1 img" style={{ backgroundImage: 'url(' + params.img + ')' }} data-aos="zoom-in" data-aos-delay="150">&nbsp;</div>
                </div>
            </div>
        </section >
    )
}
